import React from 'react'
import { Spinner } from 'react-bootstrap'
import PropTypes from 'prop-types'

const Loader = ({ button, variant, className }) => (
  <div
    className={
      button
        ? 'spinner-border button-loader'
        : `loader-container d-flex justify-content-center ${className}`
    }
  >
    {button ? null : (
      <Spinner animation="border" role="status" variant={variant ? variant : 'dark'}>
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    )}
  </div>
)

Loader.propTypes = {
  button: PropTypes.bool,
  variant: PropTypes.string,
  className: PropTypes.string,
}

export default Loader
